<template>
    <div class="pfadd-ej" :class="{ selected: added }" @click="addExercise(exercise)">
        <exercise-img-video class="pfadd-ej-thumb" :local-dialog="!isSecondDialog" :is-second-dialog="isSecondDialog"
            :video="exerciseVideo" :img="exerciseImg" :name="exercise.name" :isYoutubeVideo="!!exercise.youtubeUrl"
            @click.native.stop />
        <div class="pfadd-ej-info">
            <div class="pfadd-ej-name text-truncate">{{ exercise.name }}</div>
            <div class="pfadd-ej-sub text-truncate">{{ subline }}</div>
        </div>
        <v-btn icon small class="pfadd-ej-add" :class="{ selected: added }" @click.stop="addExercise(exercise)">
            <v-icon size="18">{{ oneExercise ? 'mdi-repeat' : (added ? 'mdi-minus' : 'mdi-plus') }}</v-icon>
        </v-btn>
    </div>
</template>

<script>

import ExerciseImgVideo from "@/components/common/routines/ExerciseImgVideo";

export default {
    components: { ExerciseImgVideo },
    props: {
        exercise: {
            type: Object,
            default: {},
        },
        added: {
            type: Boolean,
            default: false,
        },
        oneExercise: {
            type: Boolean,
            default: false,
        },
        isSecondDialog: {
            type: Boolean,
            default: false,
        }
    },
    methods: {
        addExercise(exercise) {
            let vm = this
            vm.$emit('add', exercise)
        },
    },
    computed: {
        isYoutubeVideo() {
            const vm = this
            return vm.exercise?.youtubeUrl ? true : false
        },
        exerciseImg() {
            const vm = this
            let img = vm.exercise.img || (vm.exercise?.video?.thumb) || null
            if (vm.isYoutubeVideo) img = vm.getYoutubeImgUrl(vm.exercise.youtubeUrl)
            return img
        },
        exerciseVideo() {
            const vm = this
            return vm.isYoutubeVideo ? vm.exercise?.youtubeUrl : vm.exercise?.video?.url || null
        },
        joinTypes(vm = this) {
            return vm.exercise.types.map(t => vm.typeLabel(t)).join(', ')
        },
        joinEquipments(vm = this) {
            if (!vm.exercise.equipments || vm.exercise.equipments.length === 0) return vm.$t('equipments.without')
            return vm.exercise.equipments.map(e => vm.equipmentLabel(e)).join(', ')
        },
        subline(vm = this) {
            return `${vm.joinTypes} · ${vm.joinEquipments}`
        }
    }
}
</script>

<style scoped>
.pfadd-ej {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 10px 8px;
    border-bottom: 1px solid var(--v-outline-base);
    cursor: pointer;
    transition: background 0.12s;
}

.pfadd-ej.selected {
    border-radius: 8px;
}

.theme--dark .pfadd-ej.selected {
    background: rgba(204, 255, 51, 0.06);
}

.theme--light .pfadd-ej.selected {
    background: rgba(102, 204, 204, 0.1);
}

.pfadd-ej-thumb {
    flex: 0 0 56px !important;
    max-width: 56px !important;
    min-width: 56px !important;
    height: 48px !important;
    padding: 0 !important;
    border-radius: 8px !important;
    background-size: cover !important;
    background-position: center !important;
    overflow: hidden;
    flex-shrink: 0;
}

.pfadd-ej-info {
    flex: 1;
    min-width: 0;
}

.pfadd-ej-name {
    font-size: 13px;
    font-weight: 600;
    color: var(--v-txtPrimary-base);
}

.pfadd-ej-sub {
    font-size: 11px;
    color: var(--v-txtMuted-base);
    margin-top: 2px;
}

.pfadd-ej-add {
    flex-shrink: 0;
    background: var(--v-surface2-base) !important;
}

.theme--dark .pfadd-ej-add {
    color: var(--v-primary-base) !important;
}

.theme--light .pfadd-ej-add {
    color: var(--v-secondary-base) !important;
}

.theme--dark .pfadd-ej-add.selected {
    background: var(--v-primary-base) !important;
    color: #0C0E12 !important;
}

.theme--light .pfadd-ej-add.selected {
    background: var(--v-secondary-base) !important;
    color: #fff !important;
}
</style>
